import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import { CommentInfoWrapper } from "./Comments.styled";

import CommentData from "./CommentData";

const Comments = (props) => {
  const {
    priceType,
    purchasePriceAssumption,
    specificConditions,
    transportQuotationDetails,
    concernedPollution,
    t,
  } = props;

  return (
    <CommentInfoWrapper>
      {purchasePriceAssumption && (
        <CommentData
          title={t("SOLUTION_VIEW_PURCHASE_PRICE_ASSUMPTION")}
          text={purchasePriceAssumption}
        />
      )}
      {specificConditions && (
        <CommentData
          title={t("SOLUTION_VIEW_SPECIFIC_CONDITIONS_CLIENT")}
          text={specificConditions}
        />
      )}
      {transportQuotationDetails && priceType !== 4 && (
        <CommentData
          title={t("SOLUTION_VIEW_TRANSPORT_QUOTATION_DETAILS")}
          text={transportQuotationDetails}
        />
      )}
      {concernedPollution && (
        <CommentData
          title={t("SOLUTION_VIEW_CONCERNED_POLLUTION")}
          text={concernedPollution}
        />
      )}
    </CommentInfoWrapper>
  );
};

Comments.propTypes = {
  priceType: PropTypes.number.isRequired,
  purchasePriceAssumption: PropTypes.string,
  specificConditions: PropTypes.string,
  transportQuotationDetails: PropTypes.string,
  concernedPollution: PropTypes.string,
  t: PropTypes.func.isRequired,
};

Comments.defaultProps = {
  purchasePriceAssumption: "",
  specificConditions: "",
  transportQuotationDetails: "",
  concernedPollution: "",
};

export default withTranslation()(Comments);
